import styled from 'styled-components';
import { Col, Table, Row } from 'antd';



export const InputWrappercal = styled.div`
  width : 300px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;      
  }
  input,
  .ant-select-selection--single {
    height: ${props => props.height ? props.height : '40px !important'};
  }
  .ant-select-arrow-icon {
    display: none;
  }
  input::placeholder {
    color: #d4d4d4;
  }
  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid #d4d4d4;
  }
  .ant-input {
    border-radius: 0;
    color: ${props => props.theme.border.inputBox};
    font-size: ${props => props.theme.fontSize.primary};
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};      
    }
  }
  .ant-calendar-picker-input {
    margin-top: 0 !important;
    color : ${props => props.theme.border.inputBox};
  }
`;

export const AnchorTag = styled.span`
    a {
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        font-size: ${props => props.theme.fontSize.secondary};
        font-weight: ${props => props.theme.fontWeight.normal};
        font-style: normal;
        font-stretch: ${props => props.theme.fontStretch.normal};
        line-height: ${props => props.theme.lineHeight.primary};
        letter-spacing: ${props => props.theme.letterSpacing.zero};
        color: ${props => props.theme.colors.primaryColor} !important;
        text-decoration: underline;
        word-break: break-all;
        display: inline-block;
        &.disable-hyperlink {
            color: rgba(80, 80, 80, 0.5)!important;
            pointer-events: none;
        }
        :hover {
            color: ${props => props.theme.colors.primaryColor} !important;
            text-decoration: none;
        }
        @media only screen and (min-width: 992px) {
            font-size: ${props => props.theme.fontSize.primary} !important;  
        }
        @media only screen and (max-width: 990px) {
            font-size: ${props => props.theme.fontSize.primary};
            line-height: ${props => props.theme.lineHeight.primary};
        }
        @media only screen and (max-width: 576px) {
            font-size: ${props => props.theme.fontSize.secondary};
            line-height: ${props => props.theme.lineHeight.primary};
        }
    }
`;

export const InfoTitle = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.secondary};
color:${props => props.theme.fontColors.textColor};
white-space: ${props => props.wrap ? 'normal' : 'nowrap'};
@media only screen and (min-width:991px){
    font-size: ${props => props.theme.fontSize.primary};    
}
`;

export const InfoField = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.secondary};
color:${props => props.theme.fontColors.headingColor};
overflow-wrap: break-word;
${props => props.isPrint ? 'white-space: nowrap;': ''};
${props => props.wordBreakOnly ? '': 'word-break: break-all'};
${({ apColumn }) => apColumn && `padding-bottom:15px;`}
${({ keys }) => keys && `margin-bottom:10px;`}
@media only screen and (min-width:991px){
    font-size: ${props => props.theme.fontSize.primary};    
}
`;

export const InfoInlineWrap = styled.div`
    display: flex;
    align-items: baseline;
`;

export const BoxDetailWrapper = styled(Col)`
    padding-top: 20px;    
    padding-bottom: 20px;
    ${props =>
        props.border && `border-bottom:1px solid ${props.theme.colors.border};`
    }
`;

export const DetailsContainer = styled.div`
border-top:1px solid ${props => props.theme.colors.border};
border-bottom:1px solid ${props => props.theme.colors.border};
padding-top:50px;
padding-bottom:49px;
display:flex;

${({ noBorder }) => noBorder && `border:none;`}

@media only screen and (max-width:576px){
    width:100%;
    flex-wrap:wrap;
    flex-direction:column;
}
`;

export const SmallDetails = styled.div`
font-family: ${props => props.theme.fontFamily.HelveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
${({ pad }) => pad ? `margin-top:20px;padding-bottom:0px;` : ``}
${({ padLeft }) => padLeft && `margin-left:6px;`}
${({ pad20 }) => pad20 ? `padding-top:20px;` : `padding-top:0px;`}
${({ padTop }) => padTop ? `padding-top:10px;` : `padding-top:0px;`}
${({ borderBottom }) => borderBottom ? `border-bottom:1px solid #bfbfbf;` : `border: none;`}
`;

export const PreviewLetterWrapper = styled.div`
    font-size: 1rem;
    line-height: ${props => props.theme.lineHeight.primary};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    div >a {
        font-size: 1rem;
    }
`;

export const PreviewLetterLogo = styled.img`
    width:29.5px !important;     
    height:29.7px !important;
    margin-right: 17.5px;
`;

export const PreviewLetterContainer = styled.div`
    display: inline-block;
    ${({ flexCenter }) => flexCenter && `
        display: flex;
        align-items: center;
    `}
    ${({ contentStyle, theme }) => contentStyle && `
    >span {
        font-family: ${theme.fontFamily.helveticaNeue};
        font-size: ${theme.fontSize.primary};
        line-height: ${theme.lineHeight.primary};
        letter-spacing: ${theme.letterSpacing.zero};
        color: ${theme.fontColors.thead};
    }
    `}
`;

export const Disclaimer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  b, strong {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    color: ${props => props.theme.fontColors.headingColor};
    font-weight: normal;
  }
`;

export const TermsDivision = styled.div`
padding-top:30px;
`;

export const ReviewTable = styled(Table)`
    & .ant-table-thead > tr > th {
        background: ${props => props.theme.backgroundColor.layoutLight};
        border-bottom: none;
        padding: 20px 5px 5px 0;
    }
    & .ant-table-tbody > tr > td {
        border-bottom: none;
        padding: 5px 5px 5px 0;
    }
    .ant-table-column-title {
        transform: translate(0px);
    }
`

export const ReviewScheduleTable = styled(Table)`
    & .ant-table-thead > tr > th {
        background: ${props => props.theme.backgroundColor.layoutLight};
        padding: 20px 5px 20px 0;
        font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
        font-size: ${props => props.theme.fontSize.tableFont};
        color:${props => props.theme.fontColors.headingColor};
    }
    & .ant-table-tbody > tr > td {
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        font-size: ${props => props.theme.fontSize.tableFont};
        color:${props => props.theme.fontColors.textColor};
        border-bottom: none;
        padding: 7.5px 5px 7.5px 0;
    }
    & .ant-table-tbody > tr:first-child > td {
        padding-top: 15px;
    }
`
export const AllocationWrapper = styled(Row)`
    padding-top: 20px;
`;
export const AllocationBody = styled(Row)`
    padding: 5px 0px 5px 0px;
    &:hover {
        background-color: ${props => props.theme.backgroundColor.tableAltRowDark};
    }
`;
export const BoxDetailWrapperPrint = styled(Col)`
    padding-top: 10px;
    padding-bottom: 10px;
    ${props =>
        props.border && `border-bottom:1px solid ${props.theme.colors.border};`
    }
`;
export const AllocationTableCol = styled(Col)`
    && {
        padding-right: 20px;
    }
`;

export const InfoFieldAdditionalAttribute = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};
    color:${props => props.theme.fontColors.headingColor};
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-wrap: break-word;
    ${({ apColumn }) => apColumn && `padding-bottom:15px;`}
    ${({ keys }) => keys && `margin-bottom:10px;`}
    @media only screen and (min-width:991px){
        font-size: ${props => props.theme.fontSize.primary};
    }
`;
export const AdditionalCommentWrapper = styled.div`
    white-space: pre-wrap;
`;
export const TimeLineWrapper = styled.div`
     margin:50px 0px 26px 0px;
`;